<template>
    <div class="flex h-full overflow-hidden">
        <reports-menu 
            :report-data="allReports"
            :selected-category="report.category_id"
            @category-selected="handleCategorySelected"
        />
        <project-comps-prep
            :projects="projects"
            :report-slug="report.slug"
        />
    </div>
</template>

<script>
import ReportsMenu from './ReportsMenu.vue';
import ProjectCompsPrep from './ProjectCompsPrep.vue';

export default {
    name: 'ProjectCompsPrepPage',
    
    components: {
        ReportsMenu,
        ProjectCompsPrep
    },

    props: {
        allReports: {
            type: Array,
            default: () => []
        },
        report: {
            type: Object,
            required: true
        },
        projects: {
            type: Array,
            default: () => []
        }
    },

    methods: {
        handleCategorySelected(categoryId) {
            if (categoryId === '') {
                window.location = '/reports';
            }
        }
    }
};
</script>
